import { strToU8, zipSync } from 'fflate'
import type { Zippable } from 'fflate'
import { downloadBlob, formatFileSize } from './types'

export interface ZipFileEntry {
  name: string
  content: string | Uint8Array
}

export interface ZipExportResult {
  blob: Blob
  filename: string
  size: number
  formattedSize: string
}

export function createZipBlob(entries: ZipFileEntry[]): Blob {
  const zipData: Zippable = {}

  for (const entry of entries) {
    zipData[entry.name] = typeof entry.content === 'string'
      ? strToU8(entry.content)
      : entry.content
  }

  const zipped = zipSync(zipData)
  return new Blob([new Uint8Array(zipped)], { type: 'application/zip' })
}

export function downloadZip(entries: ZipFileEntry[], filename: string): ZipExportResult {
  const blob = createZipBlob(entries)
  downloadBlob(blob, filename)

  return {
    blob,
    filename,
    size: blob.size,
    formattedSize: formatFileSize(blob.size),
  }
}

export function createZipFilename(originalFilename: string): string {
  const timestamp = Date.now()
  const baseName = originalFilename.replace(/\.(html|tsx)$/, '')
  return `${baseName}-${timestamp}.zip`
}
